// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".compiled.js?v=" + "d77e5f84c41971635e60" + "";
};